import PropTypes from "prop-types";

import AnnotationCommentDeleteActions from "./AnnotationCommentDeleteActions";
import {
  commentOverlay,
  textCss,
} from "./AnnotationCommentDeleteConfirmation.style";

const propTypes = {
  commentActionProps: PropTypes.object,
};

const AnnotationCommentDeleteConfirmation = ({ commentActionProps }) => {
  return (
    <div css={commentOverlay}>
      <p css={textCss}>Delete your comment?</p>
      <AnnotationCommentDeleteActions {...commentActionProps} />
    </div>
  );
};

AnnotationCommentDeleteConfirmation.propTypes = propTypes;
export default AnnotationCommentDeleteConfirmation;
